import React, { useState, useEffect } from 'react';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import CommonClasses from 'Styles/Common.module.css';
import TutorClasses from '../../Categories/addCategory/index.module.css';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import { Services } from 'Services';
import { Success, Error } from 'Util/Toast';
import ReactLoading from 'react-loading';
import { BsCloudUpload } from 'react-icons/bs';
import { IoIosClose } from "react-icons/io";
import { useFileUpload } from 'Util/fileUpload';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const EditGifts = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { gift } = state || {};
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [categories, setCategories] = useState([]);
    const { register, handleSubmit, setValue, control, formState: { errors } } = useForm();

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const token = { Authorization: `token ${localStorage.getItem('token')}` };
                const response = await Services.getCategories("POST", null, token);
                if (response.Status === 1) {
                    setCategories(response.Categories);
                } else {
                    Error(response.Message);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
                Error('Error fetching categories');
            }
        };

        fetchCategories();

        if (gift) {
            setValue('GiftName', gift.GiftName);
            setValue('Price', gift.Price);
            setValue('OfferPrice', gift.OfferPrice);
            setValue('GiftDescription', gift.GiftDescription);
            setValue('Material', gift.Material);
            setValue('Capacity', gift.Capacity);
            setValue('ProductDimension', gift.ProductDimension);
            setValue('TopDiameter', gift.TopDiameter);
            setValue('PackageInclude', gift.PackageInclude);
            setValue('QuantityAvailable', gift.QuantityAvailable);
            setValue('GiftStatus', gift.GiftStatus);
            setValue('ProductID', gift.ProductID);
            setValue('VendorID', gift.VendorID);
            setValue('IsReturnable', gift.IsReturnable?.toString() || '');
            setValue('IsCODAvailable', gift.IsCODAvailable?.toString() || '');
            setValue('IsTrending', gift.IsTrending || false);

            // Handle CategoryIDs
            if (Array.isArray(gift.CategoryIDs)) {
                setValue('CategoryIDs', gift.CategoryIDs);
            } else {
                console.error('CategoryIDs is not an array:', gift.CategoryIDs);
                setValue('CategoryIDs', []);
            }

            // In Edit, gift.GiftImages are likely already full URLs or filenames.
            // If they are filenames like "123.jpg", we need to display them.
            // If they are full URLs, we also display them.
            setImage(gift.GiftImages);
            setImagePreviews(gift.GiftImages);
            setValue('GiftImages', gift.GiftImages);
        }
    }, [gift, setValue]);

    const { uploadMultipleWithLoading } = useFileUpload({
        allowedTypes: ["image/png", "image/jpeg", "image/webp"],
        maxSizeInMB: 10,
        folder: "Gifts"
    });

    const filehandleChange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        setLoading(true);
        try {
            await uploadMultipleWithLoading(
                files,
                (uploadedFiles) => {
                    // Success callback
                    const newUrls = uploadedFiles.map(f => f.fileUrl);

                    setImage((prev) => {
                        const updatedImages = [...prev, ...newUrls];
                        setValue('GiftImages', updatedImages);
                        return updatedImages;
                    });
                    setImagePreviews((prev) => [...prev, ...newUrls]);
                },

                (error) => {
                    console.error("Upload Error:", error);
                }
            );
        } finally {
            setLoading(false);
        }
    };


    const removeImage = (index) => {
        const updatedImages = [...image];
        const updatedPreviews = [...imagePreviews];

        updatedImages.splice(index, 1);
        updatedPreviews.splice(index, 1);

        setImage(updatedImages);
        setImagePreviews(updatedPreviews);
        setValue('GiftImages', updatedImages);
    };

    const onSubmit = async (body) => {
        setLoading(true);
        try {
            // ProductID and VendorID are now handled as strings (varchar)

            body.GiftImages = image;

            body.IsReturnable = Number(body.IsReturnable);
            body.IsCODAvailable = Number(body.IsCODAvailable);
            body.IsTrending = body.IsTrending ? 1 : 0;
            const token = { Authorization: `token ${localStorage.getItem('token')}` };
            const response = await Services.updateGifts(gift.GiftID, "PUT", JSON.stringify(body), token);
            if (response.Status === 1) {
                setLoading(false);
                navigate('/gifts');
                Success(response.Message);
            } else {
                setLoading(false);
                Error(response.Message);
            }
        } catch (error) {
            console.error('Error updating gift:', error);
            setLoading(false);
            Error('Error updating gift');
        }
    };

    const fileuploadDesign = (
        <div className={TutorClasses["add-item"]} onClick={() => document.getElementById("image").click()}>
            <div className={TutorClasses['upload-image']}>
                {imagePreviews.map((preview, index) => (
                    <div key={index} className={TutorClasses['image-container']}>
                        <button type="button" className={TutorClasses['remove-button']} onClick={() => removeImage(index)}>
                            <IoIosClose className={TutorClasses['close-img-btn']} />
                        </button>
                        <img src={preview} alt="Selected" className={TutorClasses['uploaded-coupon-image']} />
                    </div>
                ))}
                {!imagePreviews.length && (
                    <div className={TutorClasses['add-item']} onClick={() => document.getElementById("image").click()}>
                        <BsCloudUpload className={TutorClasses['upload-icon']} />
                        <h5>Drag Your Files here</h5>
                        <p>(Only *.jpeg, *.png will be accepted)</p>
                    </div>
                )}
                <input type="file" id="image" onChange={filehandleChange} multiple style={{ display: 'none' }} />
            </div>
        </div>
    );

    return (
        <Layout Active={'Gifts'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Update Gift</title>
            </Helmet>
            <div className={CommonClasses['Container']}>
                <div className={CommonClasses["control-btns"]}>
                    <button className={CommonClasses["button"]} onClick={() => navigate(-1)}>Back</button>
                </div>
                <div className={TutorClasses['wrapper']} data-aos="zoom-in-down">
                    <h2 className={TutorClasses['main-header']}>Update Gift</h2>
                    <form className={TutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="GiftName">Gift Name</label>
                            <input type='text' {...register('GiftName')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="ProductID">ProductID</label>
                            <input type='text' {...register('ProductID')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="VendorID">VendorID</label>
                            <input type='text' {...register('VendorID')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="GiftStatus">Gift Status</label>
                            <select {...register('GiftStatus')} defaultValue={gift?.GiftStatus || ""} required>
                                <option value="">Select Gift Status</option>
                                <option value="1">Active</option>
                                <option value="2">InActive</option>
                            </select>
                        </div>
                        <div className={TutorClasses['file-upload-wrapper']}>
                            <header>
                                <h3>
                                    Upload Gift Images <span className="important">*</span>
                                </h3>
                            </header>
                            <div className={TutorClasses["upload-image"]} required>
                                {fileuploadDesign}
                            </div>
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="Price">Price</label>
                            <input type='number' step="0.01" {...register('Price')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="OfferPrice">Offer Price</label>
                            <input type='number' step="0.01" {...register('OfferPrice')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="GiftDescription">Gift Description</label>
                            <textarea {...register('GiftDescription')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="Material">Material</label>
                            <input type='text' {...register('Material')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="Capacity">Capacity</label>
                            <input type='text' {...register('Capacity')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="ProductDimension">Product Dimension</label>
                            <input type='text' {...register('ProductDimension')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="TopDiameter">Colors</label>
                            <input type='text' {...register('TopDiameter')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="PackageInclude">Package Include</label>
                            <input type='text' {...register('PackageInclude')} required />
                        </div>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="QuantityAvailable">Quantity Available</label>
                            <input type='number' {...register('QuantityAvailable')} required />
                        </div>

                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="IsReturnable">Is Returnable</label>
                            <Controller
                                name="IsReturnable"
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <FormControl fullWidth>
                                        <Select
                                            {...field}
                                            displayEmpty
                                            error={!!errors.IsReturnable}
                                        >
                                            <MenuItem value="" disabled>Select option</MenuItem>
                                            <MenuItem value="1">Yes</MenuItem>
                                            <MenuItem value="0">No</MenuItem>
                                        </Select>
                                    </FormControl>
                                )}
                            />
                            {errors.IsReturnable && <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>Is Returnable is required</p>}
                        </div>

                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="IsCODAvailable">Is COD Available</label>
                            <Controller
                                name="IsCODAvailable"
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <FormControl fullWidth>
                                        <Select
                                            {...field}
                                            displayEmpty
                                            error={!!errors.IsCODAvailable}
                                        >
                                            <MenuItem value="" disabled>Select option</MenuItem>
                                            <MenuItem value="1">Yes</MenuItem>
                                            <MenuItem value="0">No</MenuItem>
                                        </Select>
                                    </FormControl>
                                )}
                            />
                            {errors.IsCODAvailable && <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>Is COD Available is required</p>}
                        </div>

                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="CategoryIDs">Category</label>
                            <Controller
                                name="CategoryIDs"
                                control={control}
                                defaultValue={[]}
                                render={({ field: { onChange, value } }) => (
                                    <Autocomplete
                                        multiple
                                        options={categories}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.CategoryName}
                                        onChange={(event, newValue) => {
                                            const selectedOptions = newValue.map(option => option.CategoryID);
                                            onChange(selectedOptions);
                                        }}
                                        value={categories.filter(cat => value.includes(cat.CategoryID))}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.CategoryName}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Categories"
                                                variant="outlined"
                                                sx={{ width: '100%' }} // Make TextField full width
                                            />
                                        )}
                                        sx={{ width: '100%' }} // Make Autocomplete full width
                                    />
                                )}
                            />
                        </div>

                        <div className={TutorClasses['form-control']}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="checkbox"
                                    id="IsTrending"
                                    {...register('IsTrending')}
                                    style={{
                                        width: '18px',
                                        height: '18px',
                                        cursor: 'pointer'
                                    }}
                                />
                                <label htmlFor="IsTrending" style={{ cursor: 'pointer', margin: 0 }}>
                                    Make it Trending
                                </label>
                            </div>
                            <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                Check this box to mark the gift as trending
                            </p>
                        </div>

                        <button disabled={loading}>
                            {loading ? (
                                <ReactLoading color="green" type="spokes" height={30} width={30} />
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default EditGifts;
